import React from "react";
import { Provider } from "react-redux";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as JssThemeProvider } from "@mui/styles";
import { rootTheme } from "common/themes";
import Routes from "./routes";
import Bootstrap from "common/auth/components/Bootstrap";
import CssBaseline from "@mui/material/CssBaseline";
import ErrorBoundary from "core/ErrorBoundary";
import { history } from "common/store";
import "styles";

const App = ({ store }) => (
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={rootTheme}>
        <JssThemeProvider theme={rootTheme}>
          <CssBaseline />
          <Bootstrap>
            <ErrorBoundary>
              <Routes history={history} />
            </ErrorBoundary>
          </Bootstrap>
        </JssThemeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
);

export default App;
